module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-04.6ffdcdb8.svg";